import '../styles/ProductsWithList.scss';

const SacrificialAnodes = () => {
    return (
        <div className="main">
            <h1>Sacrificial Anodes</h1>
            <img className='img-reliance-logo' src='https://user-images.githubusercontent.com/77664153/180872931-86c62ec8-ea39-4534-bacb-e0a5740202e5.png' alt='Reliance Logo'></img>
            <p>In 1988 Metal Distributors branched out of the lead industry and entered the Marine Industry with our Reliance brand of Sacrificial Anodes. Produced in Aluminum and Zinc Alloys, all our anodes are produced in-house at our facility in Burnaby, BC.</p>
            <p>Our facility features a fully equipped die casting room and our own fully equipped tool room where we produce and fix all our own dies for diecasting. By producing our own dies in house and casting right on the premises, the lead time for parts and the manufacturing and maintenance of dies is quicker and of superior quality.</p>
            <h3 className='external-link'>To learn more about our sacrificial anodes, please visit <a href='http://www.relianceanodes.com' target='_blank' rel='noreferrer'>relianceanodes.com</a>.</h3>
        </div>
    );
};

export default SacrificialAnodes;